module.exports = __webpack_public_path__ + "img/cashpay.18dfa867.svg";